$ = jQuery.noConflict();

$(document).ready(function(){
	if ( $('.elementor[data-elementor-type="wp-page"] .elementor-inner-section, .elementor[data-elementor-type="search-results"] .elementor-inner-section, .elementor[data-elementor-type="single-page"] .elementor-inner-section').length ) {
		$('.elementor[data-elementor-type="wp-page"] .elementor-inner-section, .elementor[data-elementor-type="search-results"] .elementor-inner-section, .elementor[data-elementor-type="single-page"] .elementor-inner-section').each(function(){
			const columns = $(this).find('.elementor-column');
			const colNo = columns.length;
			
			gsap.set(columns, {
				opacity: 0,
				y: 16
			});
			
			ScrollTrigger.batch(columns, {
				interval: 0.1, // time window (in seconds) for batching to occur. 
				batchMax: colNo,   // maximum batch size (targets). Can be function-based for dynamic values
				onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15, grid: [1, colNo]}, overwrite: true}),
				onLeave: batch => gsap.set(batch, {opacity: 0, y: -16, overwrite: true}),
				onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
				onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 16, overwrite: true}),
				start: "top bottom",
				end: "bottom top"
			});
			
		});
	}
	
	const pageEl = $('.elementor[data-elementor-type="wp-page"], .elementor[data-elementor-type="single-page"], .elementor[data-elementor-type="search-results"]');
	pageEl.each(function(){
		const headings = $(this).find('.elementor-heading-title, .isometric-cards__title, .isometric-cards__content h3, .homepage-hero__title, .blog-preview__card.is-style-featured .blog-preview__card__link, .card-stack__title');
		headings.each(function(){
			const split = new SplitText(this, {
				type: 'lines',
				linesClass: "heading-line line++"
			});
			
			gsap.set(split.lines, {
				y: 56,
				opacity: 0
			});
			
			ScrollTrigger.create({
				trigger: this,
				start: 'top bottom',
				end: 'bottom top',
				onEnter: function() {
					gsap.to(split.lines, {
						y: 0,
						opacity: 1,
						stagger: {
							each: 0.15
						}
					});
				},
				onLeave: function() {
					gsap.set(split.lines, {
						y: -56,
						opacity: 0
					});
				},
				onEnterBack: function() {
					gsap.to(split.lines, {
						y: 0,
						opacity: 1,
						stagger: {
							each: 0.15,
							from: 'end'
						}
					});
				},
				onLeaveBack: function() {
					gsap.set(split.lines, {
						y: 56,
						opacity: 0
					});
				}
			});
		});
		
		$('.elementor-heading-title .heading-line, .isometric-cards__title .heading-line, .isometric-cards__content h3 .heading-line, .homepage-hero__title .heading-line, .blog-preview__card.is-style-featured .blog-preview__card__link .heading-line, .card-stack__title .heading-line').wrap('<div class="line-wrapper"></div>');
		
		const contentBoxes = $(this).find('.elementor-widget-text-editor, .testimonial-card, .card-stack__content, .isometric-cards__content, .homepage-hero__content-inner');
		contentBoxes.each(function() {
			const paragraphs = $(this).find('p');
			gsap.set(paragraphs, {
				opacity: 0,
				y: 16
			});
			
			ScrollTrigger.batch(paragraphs, {
				interval: 0.1, // time window (in seconds) for batching to occur. 
				batchMax: 12,   // maximum batch size (targets). Can be function-based for dynamic values
				onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15, grid: [1, 4]}, overwrite: true}),
				onLeave: batch => gsap.set(batch, {opacity: 0, y: -16, overwrite: true}),
				onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
				onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 16, overwrite: true}),
				start: "top bottom",
				end: "bottom top"
			})
		});
		
	});
});